import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, throwError } from 'rxjs';
import { AuthService } from '../auth/auth.service';

import { GlobalConstants } from '../../config/GlobalConstants';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private auth: AuthService, private router: Router) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const isPublic = GlobalConstants.PUBLIC_PATHS.some(p => req.url.includes(p));
    const token    = this.auth.token();
    const outReq   = (!isPublic && token)
      ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
      : req;

    return next.handle(outReq).pipe(
      catchError(err => {
        // 401 on a protected request means the token expired or was rejected
        if (err.status === 401 && !isPublic) {
          this.auth.logout();
        }
        return throwError(() => err);
      }),
    );
  }
}
